<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "interview"
};
</script>

<style lang="scss"></style>
